import type { FaireProductEntity } from "../../entity_types/product";

export const p_bagjhpjgk4: FaireProductEntity = {
  token: "p_bagjhpjgk4",
  type: "product",
  name: "18K Gold Two-Tone Stainless Steel Interlocking Ring",
  brandToken: "b_wxdny9yjk7",
  brandName: "Norelle",
  imageUrl:
    "https://cdn.faire.com/fastly/ebc9ce0a7ee1d0593cf06764283e7dc435e1ad1d5229cb9c6df54ae3fe2bcb64.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cda8bc59713cd07d975360e087c231e5795732622b815732154847d100e1856b.jpeg",
    "https://cdn.faire.com/fastly/15f778a7d3f81f0aacbfcc5da42c571ca1c308ba3fe645f4a372e78c9178baa7.jpeg",
    "https://cdn.faire.com/fastly/8bc945adaf11bf87394366d2f769c36f08d0ac712eaf2e78f28b9252065e964b.jpeg",
    "https://cdn.faire.com/fastly/87f07491969f1ebcb524df9063013209eec4e010d74a0059418644b93859c44b.jpeg",
    "https://cdn.faire.com/fastly/17f7ba87b63523e21740e9958ffbba609ea14aa65cf3ba5955e88741e2646fee.jpeg",
    "https://cdn.faire.com/fastly/70630d4593797be7634d868acd1ce2b90c043f7310b66fdbc050a0f93667d874.jpeg",
  ],
  priceDollars: 5.8,
  description:
    "This two-tone interlocking ring combines durability with a modern minimalist aesthetic.\n\n*Crafted from stainless steel with 18K gold plating, ensuring long-lasting shine.\n*Intertwined bands in silver and gold tones create a stylish layered look.\n*Adorned with cubic zirconia stones for subtle sparkle.\n*Waterproof, hypoallergenic, and tarnish-resistant – perfect for everyday wear.\n*Lightweight and versatile, suitable for both casual and formal jewelry collections.\n\nProduct Details\nMaterial: Stainless Steel + 18K Gold Plating\nStone: Cubic Zirconia\nDiameter: 1.80 cm / 0.71 in\nBand Thickness: 0.30 cm / 0.11 in\nWeight: 4.7 g / 0.16 oz\nSize: US 8",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:28.754Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
